// Datos expandidos para dashboard de reportes (~450 registros)
// Este archivo genera datos realistas para pruebas

const EVAL_TYPES = {
  psicologicas: 'Psicologicas',
  conocimientos: 'Conocimientos',
  otros: 'Otros'
};

const SUBTYPE_VALUES = {
  salamanca: 'SALAMANCA',
  dass21: 'DASS-21'
};

const ESTADO_POSTULACION = {
  nuevo: 'Nuevo',
  enviada: 'Enviada',
  completada: 'Completada',
  vencida: 'Vencida',
  proceso: 'Proceso',
  cancelado: 'Cancelado'
};

const NOMBRES_POSTULANTES = [
  'Maria Rojas', 'Luis Ortega', 'Ana Ponce', 'Pedro Tello', 'Camila Mora',
  'Diego Cardenas', 'Valeria Ruiz', 'Jorge Mena', 'Paola Silva', 'Rene Flores',
  'Gina Alarcon', 'Mario Loza', 'Nadia Cuellar', 'Fernando Vega', 'Lucia Prado',
  'Raul Quispe', 'Sandra Milla', 'Ivan Paredes', 'Rosa Chavez', 'Elias Torres',
  'Juan Garcia', 'Patricia Lopez', 'Carlos Martinez', 'Laura Hernandez', 'Ricardo Rodriguez',
  'Teresa Sanchez', 'Manuel Gomez', 'Angela Ramirez', 'Roberto Torres', 'Francisca Chavez',
  'Miguel Flores', 'Dolores Vargas', 'Antonio Diaz', 'Josefa Ruiz', 'Felipe Gutierrez',
  'Margarita Soto', 'Jose Medina', 'Magdalena Jimenez', 'Francisco Romero', 'Antonia Herrera'
];

const CARGOS = [
  'Docente Primaria', 'Docente Secundaria', 'Docente Inicial', 'Asistente TI', 
  'Coordinador Academico', 'Psicologo Escolar', 'Auxiliar Administrativo', 'Encargado Biblioteca',
  'Analista RRHH', 'Asistente Tesoreria', 'Secretaria Academica', 'Prefecto de Disciplina',
  'Profesor Educacion Fisica', 'Docente Especial', 'Orientador Educativo', 'Coordinador Pastoral'
];

const USUARIOS_RRHH = [
  { name: 'Carmen Reyes', weight: 0.30 },
  { name: 'Miguel Parra', weight: 0.25 },
  { name: 'Laura Gutierrez', weight: 0.25 },
  { name: 'Juan Morales', weight: 0.20 }
];

// Generar 450 registros
const generarMockData = () => {
  const data = [];
  let id = 1001;
  
  const evaluacionesPsi = [
    'Psicológica SALAMANCA - Enero', 'Psicológica SALAMANCA - Febrero', 'Psicológica SALAMANCA - Marzo',
    'Psicológica DASS-21 - Enero', 'Psicológica DASS-21 - Febrero', 'Psicológica DASS-21 - Marzo'
  ];
  
  const evaluacionesConocimiento = [
    'Conocimientos Básicos - Enero', 'Conocimientos Básicos - Febrero', 'Conocimientos Básicos - Marzo',
    'Conocimientos Avanzados - Enero', 'Conocimientos Avanzados - Febrero', 'Conocimientos Avanzados - Marzo'
  ];
  
  const evaluacionesOtros = [
    'Evaluación General - Enero', 'Evaluación General - Febrero', 'Evaluación General - Marzo',
    'Evaluación Técnica - Enero', 'Evaluación Técnica - Febrero', 'Evaluación Técnica - Marzo'
  ];
  
  // Enero: 150 registros
  for (let i = 0; i < 150; i++) {
    const tipo = i % 10 < 4 ? EVAL_TYPES.psicologicas : (i % 10 < 7 ? EVAL_TYPES.conocimientos : EVAL_TYPES.otros);
    const dia = Math.floor(Math.random() * 28) + 1;
    const fecha = `2026-01-${String(dia).padStart(2, '0')}`;
    
    let nombreEvaluacion, subtipo;
    if (tipo === EVAL_TYPES.psicologicas) {
      nombreEvaluacion = evaluacionesPsi[Math.floor(Math.random() * 3)];
      subtipo = Math.random() > 0.5 ? SUBTYPE_VALUES.salamanca : SUBTYPE_VALUES.dass21;
    } else if (tipo === EVAL_TYPES.conocimientos) {
      nombreEvaluacion = evaluacionesConocimiento[Math.floor(Math.random() * 3)];
      subtipo = null;
    } else {
      nombreEvaluacion = evaluacionesOtros[Math.floor(Math.random() * 3)];
      subtipo = null;
    }
    
    const esAprobado = Math.random() < 0.76;
    const resultado = esAprobado ? 'Aprobado' : 'Desaprobado';
    
    // Asignar usuario RRHH
    const rand = Math.random();
    let usuarioIndex = 0;
    let acum = 0;
    for (let j = 0; j < USUARIOS_RRHH.length; j++) {
      acum += USUARIOS_RRHH[j].weight;
      if (rand < acum) {
        usuarioIndex = j;
        break;
      }
    }
    const registradoPor = USUARIOS_RRHH[usuarioIndex].name;
    
    data.push({
      id: id++,
      fecha,
      postulante: NOMBRES_POSTULANTES[Math.floor(Math.random() * NOMBRES_POSTULANTES.length)],
      cargo: CARGOS[Math.floor(Math.random() * CARGOS.length)],
      tipoEvaluacion: tipo,
      subtipo,
      nombreEvaluacion,
      puntaje: Math.floor(Math.random() * 11) + 10,
      puntajeMaximo: 20,
      estadoPostulacion: Math.random() > 0.05 ? ESTADO_POSTULACION.completada : (Math.random() > 0.5 ? ESTADO_POSTULACION.proceso : ESTADO_POSTULACION.vencida),
      resultado,
      duracionMin: Math.floor(Math.random() * 35) + 30,
      intentoNum: Math.random() < 0.8 ? 1 : (Math.random() < 0.9 ? 2 : 3),
      registradoPor
    });
  }
  
  // Febrero: 150 registros
  for (let i = 0; i < 150; i++) {
    const tipo = i % 10 < 4 ? EVAL_TYPES.psicologicas : (i % 10 < 7 ? EVAL_TYPES.conocimientos : EVAL_TYPES.otros);
    const dia = Math.floor(Math.random() * 28) + 1;
    const fecha = `2026-02-${String(dia).padStart(2, '0')}`;
    
    let nombreEvaluacion, subtipo;
    if (tipo === EVAL_TYPES.psicologicas) {
      nombreEvaluacion = evaluacionesPsi[Math.floor(Math.random() * 3) + 3];
      subtipo = Math.random() > 0.5 ? SUBTYPE_VALUES.salamanca : SUBTYPE_VALUES.dass21;
    } else if (tipo === EVAL_TYPES.conocimientos) {
      nombreEvaluacion = evaluacionesConocimiento[Math.floor(Math.random() * 3) + 3];
      subtipo = null;
    } else {
      nombreEvaluacion = evaluacionesOtros[Math.floor(Math.random() * 3) + 3];
      subtipo = null;
    }
    
    const esAprobado = Math.random() < 0.76;
    const resultado = esAprobado ? 'Aprobado' : 'Desaprobado';
    
    const rand = Math.random();
    let usuarioIndex = 0;
    let acum = 0;
    for (let j = 0; j < USUARIOS_RRHH.length; j++) {
      acum += USUARIOS_RRHH[j].weight;
      if (rand < acum) {
        usuarioIndex = j;
        break;
      }
    }
    const registradoPor = USUARIOS_RRHH[usuarioIndex].name;
    
    data.push({
      id: id++,
      fecha,
      postulante: NOMBRES_POSTULANTES[Math.floor(Math.random() * NOMBRES_POSTULANTES.length)],
      cargo: CARGOS[Math.floor(Math.random() * CARGOS.length)],
      tipoEvaluacion: tipo,
      subtipo,
      nombreEvaluacion,
      puntaje: Math.floor(Math.random() * 11) + 10,
      puntajeMaximo: 20,
      estadoPostulacion: Math.random() > 0.05 ? ESTADO_POSTULACION.completada : (Math.random() > 0.5 ? ESTADO_POSTULACION.proceso : ESTADO_POSTULACION.vencida),
      resultado,
      duracionMin: Math.floor(Math.random() * 35) + 30,
      intentoNum: Math.random() < 0.8 ? 1 : (Math.random() < 0.9 ? 2 : 3),
      registradoPor
    });
  }
  
  // Marzo: 150 registros
  for (let i = 0; i < 150; i++) {
    const tipo = i % 10 < 4 ? EVAL_TYPES.psicologicas : (i % 10 < 7 ? EVAL_TYPES.conocimientos : EVAL_TYPES.otros);
    const dia = Math.floor(Math.random() * 17) + 1; // Solo hasta día 17
    const fecha = `2026-03-${String(dia).padStart(2, '0')}`;
    
    let nombreEvaluacion, subtipo;
    if (tipo === EVAL_TYPES.psicologicas) {
      nombreEvaluacion = evaluacionesPsi[Math.floor(Math.random() * 3) + 3];
      subtipo = Math.random() > 0.5 ? SUBTYPE_VALUES.salamanca : SUBTYPE_VALUES.dass21;
    } else if (tipo === EVAL_TYPES.conocimientos) {
      nombreEvaluacion = evaluacionesConocimiento[Math.floor(Math.random() * 3) + 3];
      subtipo = null;
    } else {
      nombreEvaluacion = evaluacionesOtros[Math.floor(Math.random() * 3) + 3];
      subtipo = null;
    }
    
    const esAprobado = Math.random() < 0.76;
    const resultado = esAprobado ? 'Aprobado' : 'Desaprobado';
    
    const rand = Math.random();
    let usuarioIndex = 0;
    let acum = 0;
    for (let j = 0; j < USUARIOS_RRHH.length; j++) {
      acum += USUARIOS_RRHH[j].weight;
      if (rand < acum) {
        usuarioIndex = j;
        break;
      }
    }
    const registradoPor = USUARIOS_RRHH[usuarioIndex].name;
    
    data.push({
      id: id++,
      fecha,
      postulante: NOMBRES_POSTULANTES[Math.floor(Math.random() * NOMBRES_POSTULANTES.length)],
      cargo: CARGOS[Math.floor(Math.random() * CARGOS.length)],
      tipoEvaluacion: tipo,
      subtipo,
      nombreEvaluacion,
      puntaje: Math.floor(Math.random() * 11) + 10,
      puntajeMaximo: 20,
      estadoPostulacion: Math.random() > 0.05 ? ESTADO_POSTULACION.completada : (Math.random() > 0.5 ? ESTADO_POSTULACION.proceso : ESTADO_POSTULACION.vencida),
      resultado,
      duracionMin: Math.floor(Math.random() * 35) + 30,
      intentoNum: Math.random() < 0.8 ? 1 : (Math.random() < 0.9 ? 2 : 3),
      registradoPor
    });
  }
  
  return data;
};

export default generarMockData();
